module.exports = __webpack_public_path__ + "img/40_69_013_360.d20aabe5.jpg";